import { Directive, forwardRef, Attribute } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms';
import { BaseValidator } from './base.directive';
import { ValidationTypes } from './validator-const.model';

@Directive({
    selector: '[cpqValidateEqual][formControlName],[cpqValidateEqual][formControl],[cpqValidateEqual][ngModel]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => EqualValidator), multi: true }
    ],
    standalone: false
})
export class EqualValidator extends BaseValidator implements Validator {
    constructor(@Attribute('cpqValidateEqual') public cpqValidateEqual: string,
        @Attribute('reverse') public reverse: string) {
        super();
    }

    private get isReverse() {
        if (!this.reverse) {
            return false;
        }

        return this.reverse === 'true' ? true : false;
    }

    validate(c: AbstractControl): { [key: string]: any } {
        // self value
        const v = c.value;

        // control vlaue
        const e = c.root.get(this.cpqValidateEqual);

        // value not equal
        if (e && e.value && e.value !== v) {
            return this.createMessage(ValidationTypes.cpqPasswordMatching,
                'Password and retype password fields don\'t match!');

        }

        // value equal and reverse
        if (e && v === e.value) {
            if (e.errors) {
                delete e.errors['cpqPasswordMatching'];
                if (!Object.keys(e.errors).length) {
                    e.setErrors(null);
                }
            }
        }

        // value not equal and reverse
        if (e && e.value && v !== e.value && this.isReverse) {
            return this.createMessage(ValidationTypes.cpqPasswordMatching,
                'Password and retype password fields don\'t match!');
        }

        return null;
    }
}
